// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".loading[data-v-1bace773]{align-items:center;display:flex;flex-direction:column;height:100vh;justify-content:center}.loading-spinner[data-v-1bace773]{animation:spin-1bace773 2s linear infinite;border:4px solid #f3f3f3;border-radius:50%;border-top-color:#0baf00;height:60px;margin-bottom:10px;width:60px}@keyframes spin-1bace773{0%{transform:rotate(0deg)}to{transform:rotate(1turn)}}.loading-text[data-v-1bace773]{font-size:18px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
